module.exports = __webpack_public_path__ + "img/logo.c9da1c9d.png";